import { CHANNEL_TYPES, PROVIDER_TYPES } from '@/vars/general'

/**
 * Channels that can work in Multichat when connected via DH providers.
 * Always use CHANNEL_TYPES / PROVIDER_TYPES — never hardcode string literals.
 */
export const MULTICHAT_CHANNEL_DEFS = [
    {
        key: 'whatsapp' as const,
        connectorType: CHANNEL_TYPES.whatsappChannel,
        dhProviderType: PROVIDER_TYPES.whatsappDh,
        displayName: 'WhatsApp',
        qrTitle: 'Откройте WhatsApp Business на рабочем телефоне',
        qrText: 'Настройки → Связанные устройства → Привязать устройство.',
    },
    {
        key: 'telegram' as const,
        connectorType: CHANNEL_TYPES.telegramChannel,
        dhProviderType: PROVIDER_TYPES.telegramDh,
        displayName: 'Telegram',
        qrTitle: 'Откройте Telegram на рабочем телефоне',
        qrText: 'Настройки Telegram → Устройства → Подключить устройство.',
    },
    {
        key: 'max_number' as const,
        connectorType: CHANNEL_TYPES.maxChannel,
        dhProviderType: PROVIDER_TYPES.maxDh,
        displayName: 'MAX',
        qrTitle: 'Откройте MAX на рабочем телефоне',
        qrText: 'Профиль → Устройства → Войти по QR-коду.',
    },
    {
        key: 'max_business' as const,
        connectorType: CHANNEL_TYPES.maxBusiness,
        dhProviderType: PROVIDER_TYPES.maxBusiness,
        displayName: 'MAX Business',
        qrTitle: '',
        qrText: '',
    },
    {
        key: 'sms' as const,
        connectorType: CHANNEL_TYPES.smsChannel,
        dhProviderType: PROVIDER_TYPES.smsGate,
        displayName: 'SMS DH',
        qrTitle: '',
        qrText: '',
    },
] as const

export type MultichatChannelKey = (typeof MULTICHAT_CHANNEL_DEFS)[number]['key']

export const MULTICHAT_STANDARD_KEYS: MultichatChannelKey[] = [
    'whatsapp',
    'telegram',
    'max_number',
]

export function getMultichatChannelDef(key: MultichatChannelKey) {
    return MULTICHAT_CHANNEL_DEFS.find((item) => item.key === key) || null
}

export function getMultichatChannelDefByConnectorType(connectorType?: string | null) {
    if (!connectorType) return null
    return MULTICHAT_CHANNEL_DEFS.find((item) => item.connectorType === connectorType) || null
}

/** True when connector is Multichat-ready via the DH provider for its channel type. */
export function isMultichatDhProvider(
    connectorType?: string | null,
    providerType?: string | null
): boolean {
    const def = getMultichatChannelDefByConnectorType(connectorType)
    if (!def || !providerType) return false
    return def.dhProviderType === providerType
}

/** Channel type is one of Multichat-supported CHANNEL_TYPES, but provider is not the DH one. */
export function isMultichatExternalProvider(
    connectorType?: string | null,
    providerType?: string | null
): boolean {
    const def = getMultichatChannelDefByConnectorType(connectorType)
    if (!def) return false
    if (!providerType) return true
    return def.dhProviderType !== providerType
}
